import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import * as convertKeys from 'convert-keys';
import { ApiService } from './api.service';
import { Site } from '../model/site.model';

@Injectable()
export class SiteService {
  conflictError = new Subject<any[]>();
  readonly sites$ = new BehaviorSubject<Site[]>([]);
  readonly selectedSite$ = new BehaviorSubject<string>(null);
  loadingSites$ = new BehaviorSubject<boolean>(false);
  siteSelection$ = new BehaviorSubject<string>(null);
  private siteResolutionCompleteSubject = new BehaviorSubject<boolean>(true);
  siteResolutionComplete$ = this.siteResolutionCompleteSubject.asObservable();
  isFirst = true;
  constructor(private apiService: ApiService) {}

  async getSites(orgId: string) {
    this.loadingSites$.next(true);
    try {
      const { data: sites } = await this.apiService.get(`organizations/${orgId}/sites`);
      this.sites$.next(convertKeys.toCamel(sites));
      return sites;
    } catch (err) {
      console.log(`Could not load Sites`, err);
      this.sites$.next([]);
      return [];
    } finally {
      this.loadingSites$.next(false);
    }
  }

  getSitesList() {
    return this.sites$;
  }

  getSelectedSite() {
    return this.selectedSite$;
  }

  setSelectedSite(siteID) {
    this.selectedSite$.next(siteID);
  }
  selectSite(siteID) {
    this.siteSelection$.next(siteID);
  }

  markSiteResolutionPending(): void {
    this.siteResolutionCompleteSubject.next(false);
  }

  markSiteResolutionComplete(): void {
    this.siteResolutionCompleteSubject.next(true);
  }

  getIsFirst() {
    return this.isFirst;
  }

  setIsFirst(value: boolean) {
    this.isFirst = value;
  }
}
